module.exports = __webpack_public_path__ + "assets/media/bfv_mian_theme.fa208bd5.mp3";